<template lang="pug">
    v-dialog( fullscreen max-width="80%" v-model="open" )
        v-toolbar( color="grey darken-4" dark sticky flat )
            v-toolbar-title Detalle de Nota de Débito  
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-card
            v-layout.pa-3( row wrap )
                v-flex( xs12 )
                    crud-form(:fields="fld" noButtons)
                        
            
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { getFetchDataFunction } from '@/services/api/DataTableServiceFromFinanzas'


import fieldForm from './fieldForm'
export default {
    name: 'invoice-Detail',
    props: {
        debitNoteId: {
            type: Number,
            required: true,
        },
        /**
         * @description
         */
        readOnly: {
            type: Boolean,
            default: () => false,
        },
        debitNoteModel: {
            type: Function,
            required: true,
        },
    },
    data: function() {
        return {
            open: false,
            service: {
                dtFetchData: () => {},
                dtDeleteItem: () => {},
            },
            fieldsForm: fieldForm,
        }
    },
    computed: {
        /**
         * @description
         */
        fld: function() {
            if (this.readOnly)
                return this.fieldsForm.map(field => {
                    field.type = 'readonly'
                    return field
                })
            return this.fieldsForm
        },
    },
    methods: {
        toggleOpen() {
            this.open = !this.open
        },
        /**
         *
         */
        async getGeneralInfoCreditNote() {
            const include = ['sl_detail_sale_credit_notes.wh_product']
            let response = await this.debitNoteModel
                // .include(include)
                .find(this.debitNoteId)
            console.log(response, 'response')
            this.fillForm(response)
        },
        /**
         *
         */
        fillForm(data) {
            console.log(data, 'data fillform')
            let fields = [...this.fieldsForm]
            fields[0].value = 'Nota de Débito'
            fields[1].value = data.number
            fields[2].value = this.typeSiiDocument(data)
            fields[3].value = data.referenced_dte_number
            fields[4].value = data.net_total
            fields[5].value = data.iva
            fields[6].value = data.total
            fields[7].value = data.global_discount_apply_percentage || 0
            fields[8].value = data.global_discount_apply_amount || 0
            fields[9].value = data.reason || 'sin motivo'
            this.fieldsForm = [...fields]
        },
        /**
         *
         */
        typeSiiDocument(data) {
          let code = null
            const SII_DOCUMENTS = [
                {
                    code: 33,
                    name: 'Factura Electrónica',
                },
                {
                    code: 39,
                    name: 'Boleta Electrónica',
                },
                {
                    code: 61,
                    name: 'Nota de crédito',
                },
            ]
            if(data.sl_sale_ticket_id){
              code = 39
            }
            else if(data.sl_sale_invoice_id){
              code = 33
            }
            else if(data.sl_sale_credit_note_id){
              code = 61
            }
            else{
              code = 0 //no  encontrado
            }
            
            let foundDocument = SII_DOCUMENTS.filter(item => {
                if (item.code === code) {
                    return item
                }
            })
            return foundDocument.length> 0
                ? foundDocument[0].name
                : `código ${code} no encontrado`
        },
    },
    watch: {
        open(val) {
            if (val == true) {
                this.getGeneralInfoCreditNote()
            }
        },
    },
    components: {
        CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // mounted: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // beforeUpdate: function(){...},
    updated: function() {
        //this.getInvoiceRecentInformation()
    },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
